/**
 * The player's one name, asked once and used everywhere: the vs-computer table,
 * creating or joining a friends game, scorecards and results. Stored under
 * KEYS.name (the same key the friends flow always used, so a name saved there
 * carries over). Always cleaned the way the server cleans it.
 */
import { NAME_MAX_LENGTH, cleanName } from '../../worker/protocol';
import { KEYS, load, save } from './storage';

export { NAME_MAX_LENGTH };

/** The saved name, cleaned, or null if the player has never given one. */
export function loadPlayerName(): string | null {
  return cleanName(load<unknown>(KEYS.name, ''));
}

/** Clean and save a name. Returns the saved name, or null (and saves nothing) if it was blank. */
export function savePlayerName(raw: string): string | null {
  const name = cleanName(raw);
  if (name) save(KEYS.name, name);
  return name;
}
